import { makeStyles, createStyles, Theme } from 'styles/utils';

export const useStyles = makeStyles((_theme: Theme) => createStyles({
  noMarginForm: {
    margin: '0px !important',
    minHeight: 'initial !important',
  }
}));
